import hotkeys from 'hotkeys-js'

import { Result } from '@blade/std-lib'
import { PlatformUtil } from '@root/shared'
import { UnknownError } from '@root/shared/core/Error/Error'
import { showErrorSnackbarAction } from '@root/shared/ui'

import type { ShortcutRouter } from './shortcut-router'
import type { Ctx } from '@reatom/framework'

export const listenShortcuts = (options: {
  ctx: Ctx
  router: ShortcutRouter
}) => {
  for (const [_id, handler] of Object.entries(options.router)) {
    const hotkeysOptions = PlatformUtil.is('tauri')
      ? { keyup: true, keydown: false } // for tauri
      : { capture: true } // for browser

    hotkeys(handler.command, hotkeysOptions, (event) => {
      handler.handler({ ctx: options.ctx, event }).then((handlerResult) => {
        if (Result.isFailure(handlerResult)) {
          showErrorSnackbarAction(options.ctx, new UnknownError({}))
        }
      })

      return false
    })
  }

  return {
    unsubscribe: () => {
      for (const [_id, handler] of Object.entries(options.router)) {
        hotkeys.unbind(handler.command)
      }
    },
  }
}
